import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
const { $ } = window

export default {
	init() {
		// $('h1').fitText(0.8)
	},
	finalize() {
		// JavaScript to be fired on the home page, after the init JS
	},
}
